<template>
    <field-wrapper
        id="customerEmail"
        :label-text="texts.label"
        :error-text="errorMessage"
        :show-error="Boolean(errorMessage)"
    >
        <input-text
            id="customerEmail_input"
            v-model="value"
            type="email"
            autocomplete="email"
            aria-describedby="customerEmail_error"
            :aria-invalid="errorMessage ? 'true' : 'false'"
        />
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import InputText from "@/components/inputs/InputText";

import { mapGetters, mapMutations } from "vuex";

export default {
    components: {
        FieldWrapper,
        InputText
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return this.$t("field_customer_email");
        },
        value: {
            get() {
                return this.email || "";
            },
            set(email) {
                this.updateCustomer({ email });
            }
        },
        errorMessage() {
            if (this.validate && this.error)
                return this.$t(`field_customer_email.${this.error}`, 1, {
                    invalidChars: this.invalidChars.join("")
                });
            return null;
        },
        ...mapGetters({
            email: "customer/getEmail",
            invalidChars: "customer/getEmailInvalidChars",
            error: "customer/getEmailError"
        })
    },
    methods: {
        ...mapMutations({
            updateCustomer: "customer/updateCustomer"
        })
    }
};
</script>
